import { Injectable } from '@angular/core';
import { API_BASE_URL } from '../../../core/providers/constants/api.constants';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MachineWorkOrder } from '../types/machine-work-order';

@Injectable({
  providedIn: 'root',
})
export class ApiRouteMachineOrdersService {
  private url = API_BASE_URL + '/machines-orders';

  constructor(private readonly http: HttpClient) {}

  setAsNotRunning(machineId: number, workOrderId: number): Observable<any> {
    console.log(machineId, workOrderId);
    return this.http.patch(`${this.url}/not-running`, {
      machineId,
      workOrderId,
    });
  }

  setCurrentShift(id: number, body: { shiftId: number }): Observable<any> {
    return this.http.patch(`${this.url}/${id}/current-shift`, {
      ...body,
    });
  }

  update(
    id: number,
    body: Partial<MachineWorkOrder>
  ): Observable<MachineWorkOrder> {
    return this.http.patch<MachineWorkOrder>(`${this.url}/${id}`, {
      ...body,
    });
  }
}
